import styled from 'styled-components';
import { useAnimatedPositionTransition } from 'utils/hooks/useAnimatedPositionTransition';
import { useFbcaTranslations } from '../../hooks/useTranslations';

const Wrapper = styled.li`
  margin: 40px 0;
  display: grid;
  grid-gap: 10px;
  ${({ theme }) =>
    `grid-template-columns: ${theme.spacing.values.x4} min-content 1fr ${theme.spacing.values.x4}`};
  align-items: center;
`;

const Border = styled.div`
  display: block;
  height: ${({ theme }) => theme.spacing.values.single};
  background-color: #bdbdbd;
`;

const Text = styled.div`
  font-size: ${({ theme }) => theme.styles.fontSizes.s11};
  letter-spacing: ${({ theme }) => theme.styles.letterSpacing.pos200};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  text-transform: uppercase;
  white-space: nowrap;
`;

export const AdAccountDivider = () => {
  const { t } = useFbcaTranslations();

  return (
    <Wrapper data-test="selected-divider" ref={useAnimatedPositionTransition()}>
      <Border />
      <Text>{t('divider.label')}</Text>
      <Border />
    </Wrapper>
  );
};
